import { ITelemetryLogger } from '@cian/telemetry/shared';
import { makeLoadScript } from '../../../utils/loadScript';
import { EPaymentProvider } from '../../../types/redux/paymentMethods';
import { PROVIDER_URLS, TELEMETRY_PREFIXES } from './constants';

interface IParams {
  telemetry: ITelemetryLogger;
}

const loadScript = makeLoadScript();

export const loadPaymentProviderScript =
  (params: IParams) =>
  async (provider: EPaymentProvider): Promise<void> => {
    const { telemetry } = params;

    const telemetryPrefix = TELEMETRY_PREFIXES[provider];

    telemetry.increment(`${telemetryPrefix}.load`);

    try {
      const url = PROVIDER_URLS[provider];

      await loadScript(url);

      telemetry.increment(`${telemetryPrefix}.load_success`);

      return Promise.resolve();
    } catch {
      telemetry.increment(`${telemetryPrefix}.load_fail`);

      return Promise.reject();
    }
  };
